module.exports = __webpack_public_path__ + "img/AFMS_MB_LWN.16124297.png";